import React from "react";
import Dot from "./charts-data-point.svg?react";

export const CustomizedDot = (props: any) => {
  const { cx, cy } = props;

  return <Dot x={cx - 17} y={cy - 17} width={34} height={34} />;
};
